
import Vue, { PropType } from 'vue';

// Services & types
import CandidateService from '~/services/CandidateService';
import { ProfileImportResult, SourceType } from '~/services/types/import';
import { anySectionNeedAttention } from '~/utils/candidate/ProfileImportHelper';
import { format } from '~/utils/date-fns';
import { parseISO } from 'date-fns';

// Components
import Select from '~/components/builders/Base/Select.vue';
import InfoBox from '~/components/profile/components/InfoBox.vue';

export default Vue.extend({
    name: 'ImportSummaryForm',
    components: {
        Select,
        InfoBox,
    },
    props: {
        profileImportResult: {
            type: Object as PropType<ProfileImportResult>,
            required: true,
        },
    },
    data() {
        return {
            candidateService: new CandidateService(),

            show: true,
        };
    },
    computed: {
        sourceType(): string | null {
            if (this.profileImportResult === null) return null;
            switch (this.profileImportResult.sourceType) {
                case SourceType.LinkedIn:
                    return String(this.$t('profile.import.importPopup.sourceTypeLinkedIn'));
                case SourceType.CV:
                    return String(this.$t('profile.import.importPopup.sourceTypeCV'));
                default:
                    return null;
            }
        },
        importedAt(): string {
            return format(parseISO(this.profileImportResult.createdAt.toString()), 'dd.MM.yyyy');
        },
        anySectionNeedAttention(): boolean {
            return anySectionNeedAttention(this.profileImportResult.result.sections);
        },
    },
    methods: {
        onClose() {
            this.candidateService
                .updateLastProfileImportReviewed(this.profileImportResult.id, true)
                .finally(() => {
                    window.dispatchEvent(new CustomEvent('candidate:profile:update'));
                });
            this.show = false;
        },
    },
});
